<script>
export default {
  props: {
    size: {
      type: String,
      default: '18',
    },
  },
}
</script>
<template>
  <svg
    style="fill: currentColor"
    viewBox="0 0 10 6"
    :width="size"
    :height="size"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.63385 5.07322C9.34095 5.36612 8.86608 5.36612 8.57319 5.07322L5.10352 1.60355L1.63385 5.07322C1.34095 5.36612 0.866079 5.36612 0.573185 5.07322C0.280293 4.78033 0.280293 4.30546 0.573185 4.01256L4.21963 0.366117C4.70779 -0.122038 5.49924 -0.122039 5.9874 0.366116L9.63385 4.01256C9.92674 4.30546 9.92674 4.78033 9.63385 5.07322Z"
      fill="#1C1C1C"
    />
  </svg>
</template>
